import { xor } from 'lodash';
import moment from 'moment';
import Qs from 'qs';
import assertionsDefs from './custom-assertions-defs';

/**
 * name: hCustomValidate
 * @param {any} value - element do walidacji
 * @param {Array} assertions - obiekt z asercjami
 * @returns {Object} wynik asercji
 */
export const hCustomValidate = (value, assertions) => {
  const errors = [];

  assertions.forEach((assertion) => {
    const assertionName = assertion.split('-')[0];
    const additionalCondition = assertion.split('-')[1];

    if (!assertionsDefs[assertionName].check(value, additionalCondition)) {
      errors.push({
        assertion,
        message: assertionsDefs[assertionName].message(additionalCondition),
      });
    }
  });

  return {
    isPass: errors.length === 0,
    errors,
  };
};

/**
 * Przygotwuje obiekt z filtrami dla listy połączęń do wymagań
 * API. Głównie zamienia wartości tablicowe na ciąg znaków po przecinku
 * @param {any} object
 * @returns {Object} convertedObject - obiekt po konwersji
 */
export const hPrepareConnectionsFilterObjectToApiRequirements = (object) => {
  const convertedObject = {};
  Object.keys(object)
    .forEach((key) => {
      if (key === 'date') {
        const dateFrom = moment(object[key][0]).format('YYYY-MM-DD HH:mm:ss');
        const dateTo = moment(object[key][1]).format('YYYY-MM-DD HH:mm:ss');
        convertedObject[key] = object[key].length > 0 ? `${dateFrom}_${dateTo}` : null;
      } else {
        convertedObject[key] = object[key].length > 0 ? object[key].join(',') : null;
      }
    });
  return convertedObject;
};

/**
 * nazwa: hShortenNumber
 * @param {Object} number - numer z formularza
 * @return {Object} - numer telefonu odpowiedniej dlugości
 */
export const hShortenNumber = number => (number.length > 9 ? number.substring(0, 9) : number);

/**
 * nazwa: hValidatePhoneNumber
 * @param {Object} number - numer z formularza
 * @return {Object} - numer telefonu odpowiedniej dlugości
 */
export const hValidatePhoneNumber = number => new Promise((resolve, reject) => {
  const _number = number.replace('+48 ', '').replace(/\s/g, '');
  if (_number.length < 9) {
    reject();
  } else {
    resolve(_number);
  }
});

/**
 * nazwa: hDeepCopy
 * @param {Object} object - obiekt ze stanu aplikacji
 * @return {Object} - kopia obiektu ze stanu aplikacji
 */
export const hDeepCopy = object => JSON.parse(JSON.stringify(object));

/**
 * Usuwa (jeżeli jest) lub dodaje (jeżeli nie ma) element do tablicy.
 * Wykorzystuje funkcje _.xor() z biblioteki lodash
 * @param {Array} array
 * @param {any} item
 * @returns {Array} newArray
 */
export const hToggleArrayItem = (array, item) => xor(array, [item]);

export const hRemoveItemInArray = (array, item) => {
  const index = array.indexOf(item);
  if (index > -1) {
    array.splice(index, 1);
  }
};

export const hObjectIsEmpty = obj => Object.keys(obj).length === 0;

export const hMapColectionAsFilterObject = (collection, { asLabel, asValue }) => collection.map(item => ({
  label: item[asLabel],
  value: item[asValue],
}));

export const hParseToFilterCriteriaObjectRequiredByApi = (filterCriteria) => {
  const parsedFilterCriteria = {};

  Object.keys(filterCriteria).forEach((item) => {
    parsedFilterCriteria[item] = filterCriteria[item].value;
  });

  return parsedFilterCriteria;
};

export const hCalculateSummaryOfProducts = (productsList) => {
  if (productsList.length <= 1) {
    return {
      quantity: productsList[0] ? productsList[0].quantity : 0,
      amount: productsList[0] ? productsList[0].amount : 0,
    };
  }

  const summaryQuantity = [];
  const summaryAmount = [];

  productsList.forEach((item) => {
    summaryQuantity.push(item.quantity);
    summaryAmount.push(item.quantity * item.amount);
  });

  return {
    quantity: summaryQuantity.reduce((prev, next) => prev + next, 0),
    amount: summaryAmount.reduce((prev, next) => prev + next, 0),
  };
};

export const hDeepClone = obj => JSON.parse(JSON.stringify(obj));

export function hBasename(path, suffix) {
  let b = path;
  const lastChar = b.charAt(b.length - 1);

  if (lastChar === '/' || lastChar === '\\') {
    b = b.slice(0, -1);
  }

  b = b.replace(/^.*[/\\]/g, '');

  if (typeof suffix === 'string' && b.substr(b.length - suffix.length) === suffix) {
    b = b.substr(0, b.length - suffix.length);
  }

  return b;
}

export function hGetPathinfo(path, options) {
  let optionsCurrent = options;
  let realOpt = '';
  let optTemp = 0;
  const tmpArr = {};
  let cnt = 0;
  let i = 0;
  let haveBasename = false;
  let haveExtension = false;
  let haveFilename = false;

  if (!path) {
    return false;
  }
  if (!options) {
    optionsCurrent = 'PATHINFO_ALL';
  }

  // Initialize binary arguments. Both the string & integer (constant) input is
  // allowed
  const OPTS = {
    PATHINFO_DIRNAME: 1,
    PATHINFO_BASENAME: 2,
    PATHINFO_EXTENSION: 4,
    PATHINFO_FILENAME: 8,
    PATHINFO_ALL: 0,
  };
  // PATHINFO_ALL sums up all previously defined PATHINFOs (could just pre-calculate)
  Object.keys(OPTS).forEach((key) => {
    if (OPTS[key]) {
      OPTS.PATHINFO_ALL = OPTS[key];
    }
  });
  if (typeof optionsCurrent !== 'number') {
    // Allow for a single string or an array of string flags
    optionsCurrent = [].concat(optionsCurrent);
    for (i = 0; i < options.length; i += 1) {
      // Resolve string input to bitwise e.g. 'PATHINFO_EXTENSION' becomes 4
      if (OPTS[optionsCurrent[i]]) {
        optTemp = OPTS[optionsCurrent[i]];
      }
    }
    optionsCurrent = optTemp;
  }

  // Internal Functions
  const _getExt = (pathItem) => {
    const str = `${pathItem}`;
    const dotP = str.lastIndexOf('.') + 1;
    const strCurrent = dotP !== str.length ? str.substr(dotP) : '';

    return !dotP ? false : strCurrent;
  };

  // Gather path infos
  if (options && OPTS.PATHINFO_DIRNAME) {
    const dirName = path.replace(/\\/g, '/').replace(/\/[^/]*\/?$/, ''); // dirname
    tmpArr.dirname = dirName === path ? '.' : dirName;
  }

  if (options && OPTS.PATHINFO_BASENAME) {
    if (haveBasename === false) {
      haveBasename = hBasename(path);
    }
    tmpArr.basename = haveBasename;
  }

  if (options && OPTS.PATHINFO_EXTENSION) {
    if (haveBasename === false) {
      haveBasename = hBasename(path);
    }
    if (haveExtension === false) {
      haveExtension = _getExt(haveBasename);
    }
    if (haveExtension !== false) {
      tmpArr.extension = haveExtension;
    }
  }

  if (options && OPTS.PATHINFO_FILENAME) {
    if (haveBasename === false) {
      haveBasename = hBasename(path);
    }
    if (haveExtension === false) {
      haveExtension = _getExt(haveBasename);
    }
    if (haveFilename === false) {
      haveExtension = haveExtension ? haveExtension.length + 1 : haveExtension;
      haveExtension = haveExtension === false ? 0 : 1;

      haveFilename = haveBasename.slice(0, haveBasename.length - haveExtension);
    }

    tmpArr.filename = haveFilename;
  }

  // If array contains only 1 element: return string
  cnt = 0;
  Object.keys(tmpArr).forEach((optItem) => {
    if (tmpArr[optItem]) {
      cnt += 1;
      realOpt = optItem;
    }
  });
  if (cnt === 1) {
    return tmpArr[realOpt];
  }

  // Return full-blown array
  return tmpArr;
}

export function hConvertImageToBase64(file = {}, callback = () => {
}) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(file);
}

export function hSerializeHttpParams(httpParams) {
  const serializedParams = Qs.stringify(httpParams, {
    arrayFormat: 'brackets',
    encode: false,
  });

  // add serialized empty params
  const serializedEmptyParams = Object.keys(httpParams)
    .filter(param => typeof httpParams[param] === 'object' && hObjectIsEmpty(httpParams[param]))
    .map(param => `${param}[]`)
    .join('&');

  const _emptyParams = serializedEmptyParams.length === 0 ? '' : `&${serializedEmptyParams}`;
  return `${serializedParams}${_emptyParams}`;
}

export function _toHHMMSS(time) {
  let secNum = parseInt(time, 10);
  let hours = Math.floor(secNum / 3600);
  let minutes = Math.floor((secNum - (hours * 3600)) / 60);
  let seconds = secNum - (hours * 3600) - (minutes * 60);

  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${hours}:${minutes}:${seconds}`;
}

export function _getLabelsFromObject(arrayOfObjects, value) {
  let tempLabelArr = [];
  // eslint-disable-next-line array-callback-return
  value.map((elem, index) => {
    // eslint-disable-next-line array-callback-return
    arrayOfObjects.filter((val) => {
      if (val.value === elem) {
        tempLabelArr.splice(index + 1, 0, val.label);
      }
    });
  });
  return tempLabelArr;
}

const addLeadingZero = number => (number < 10 ? `0${number}` : `${number}`);

export const hCreateTimeInterval = (fromTime, untilTime) => {
  let until = Date.parse(`01/01/2001 ${untilTime}`);
  let from = Date.parse(`01/01/2001 ${fromTime}`);
  //* 2 because because we want every 30 minutes instead of every hour
  let max = (Math.abs(until - from) / (60 * 60 * 1000)) * 2;
  let time = new Date(from);
  let hours = [];
  for (let i = 0; i <= max; i += 1) {
    // doubleZeros just adds a zero in front of the value if it's smaller than 10.
    let hour = addLeadingZero(time.getHours());
    let minute = addLeadingZero(time.getMinutes());
    hours.push(`${hour}:${minute}`);
    time.setMinutes(time.getMinutes() + 30);
  }
  return hours;
};
